import { RISE_RESEND_INVITE_TIME_HOURS } from '@monorepo/types';
import dayjs from 'dayjs';

export const canResendInvite = (invitedDate?: Date): boolean => {
  if (!invitedDate) {
    return true;
  }

  const resendDate = dayjs().subtract(RISE_RESEND_INVITE_TIME_HOURS, 'hour');

  return dayjs(invitedDate).isBefore(resendDate);
};
